/**
 * Get the height of the viewport
 * @returns {number} The height of the viewport in pixels
 */
const getViewportHeight = () => window.innerHeight || document.documentElement.clientHeight;

/**
 * Get the width of the viewport
 * @returns {number} The width of the viewport in pixels
 */
const getViewportWidth = () => window.innerWidth || document.documentElement.clientWidth;

/**
 * @typedef {object} PositionRelativeToViewport
 * @property {boolean} isAbove
 * @property {boolean} isBelow
 * @property {boolean} isIntersecting
 */

/**
 * Check where is an element relative to the viewport: above, below or
 * intersecting.
 * @param {Element} element Element of the DOM to check
 * @returns {PositionRelativeToViewport} The position
 */
function getPositionRelativeToViewport(element) {
  const {
    top, right, bottom, left,
  } = element.getBoundingClientRect();

  const viewportBounds = {
    top: 0,
    bottom: getViewportHeight(),
    left: 0,
    right: getViewportWidth(),
  };

  const isAbove = bottom < viewportBounds.top;
  const isBelow = top > viewportBounds.bottom;
  const isOutOfViewportHorizontally = right < viewportBounds.left || left > viewportBounds.right;
  const isIntersecting = !isAbove && !isBelow && !isOutOfViewportHorizontally;

  return {
    isAbove,
    isBelow,
    isIntersecting,
  };
}

/**
 * Check whether an element is partially visible in Viewport (even by a few
 * pixels).
 * @param {Element} element - Element of the DOM to check
 * @returns {boolean} - true if is visible; otherwise, false
 */
function isInViewport(element) {
  return getPositionRelativeToViewport(element).isIntersecting;
}

export {
  getPositionRelativeToViewport,
  getViewportHeight,
  getViewportWidth,
  isInViewport,
};
